import MonthlyFinancialPositionItem from './MonthlyFinancialPositionItem';
import type { IMonthlyFinancialPositionForeseeableFinancialChanges } from './MonthlyFinancialPositionForeseeableFinancialChanges.interface';

export default class MonthlyFinancialPositionForeseeableFinancialChanges
  implements IMonthlyFinancialPositionForeseeableFinancialChanges {
  debtCommitmentsCeasing: MonthlyFinancialPositionItem;
  incomeIncreasing: MonthlyFinancialPositionItem;
  expenseDecreasing: MonthlyFinancialPositionItem;
  newDebtCommitments: MonthlyFinancialPositionItem;
  incomeDecreasing: MonthlyFinancialPositionItem;
  expenseIncreasing: MonthlyFinancialPositionItem;
  total: MonthlyFinancialPositionItem;

  static build = (data: IMonthlyFinancialPositionForeseeableFinancialChanges) =>
    new MonthlyFinancialPositionForeseeableFinancialChanges(data);

  static blank = () => new MonthlyFinancialPositionForeseeableFinancialChanges();

  /**
   * Constructor
   * @param {IMonthlyFinancialPositionForeseeableFinancialChanges} data
   */
  constructor(data?: IMonthlyFinancialPositionForeseeableFinancialChanges) {
    this.debtCommitmentsCeasing = new MonthlyFinancialPositionItem(
      data?.debtCommitmentsCeasing
    );
    this.incomeIncreasing = new MonthlyFinancialPositionItem(data?.incomeIncreasing);
    this.expenseDecreasing = new MonthlyFinancialPositionItem(data?.expenseDecreasing);
    this.newDebtCommitments = new MonthlyFinancialPositionItem(data?.newDebtCommitments);
    this.incomeDecreasing = new MonthlyFinancialPositionItem(data?.incomeDecreasing);
    this.expenseIncreasing = new MonthlyFinancialPositionItem(data?.expenseIncreasing);
    this.total = new MonthlyFinancialPositionItem(data?.total);
  }
}
